var map = {
	"./banana.obj": 133,
	"./bunny.obj": 134,
	"./chess.obj": 135,
	"./cow.obj": 136,
	"./cube.obj": 137,
	"./donut.obj": 138,
	"./frame.obj": 139,
	"./humanoid_tri.obj": 140,
	"./ico.obj": 141,
	"./mechpart.obj": 142,
	"./octahedron.obj": 143,
	"./octus.obj": 144,
	"./piramis.obj": 145,
	"./stell.obj": 146,
	"./t.obj": 147,
	"./teddy.obj": 148,
	"./tet.obj": 149,
	"./tetra.obj": 150,
	"./tetra_t.obj": 151,
	"./tetrahedron.obj": 152,
	"./torus.obj": 153,
	"./venus.obj": 154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 132;